module.exports = __webpack_public_path__ + "static/img/owe.8b1ee04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/owe.png
// module id = oaAR
// module chunks = 1